import { Modal } from 'antd';

const ReferenceDocumentModal = ({ open, onOk, onCancel }) => {
    return (
        <Modal
            open={open}
            title="提示"
            onOk={onOk}
            onCancel={onCancel}
            cancelButtonProps={{
                style: {
                    display: 'none',
                },
            }}
        >
            <div>
                <div>为了生成文章内容的准确，建议您填写参考文献！</div>
            </div>
        </Modal>
    );
};

export default ReferenceDocumentModal;
